import { bffServiceInstanceAdmin } from "@/plugins/api_service/services";

const prefix = "/admin/auth";

export default {
  login: (credential) =>
    bffServiceInstanceAdmin.post(`${prefix}/login`, {}, credential), // email, password
  logout: () => bffServiceInstanceAdmin.post(`${prefix}/logout`, {}, {}),
};
